import {inject, Injectable} from '@angular/core';
import {FilesParamsService} from "../../files-modal/services/files-params.service";
import {ModalsService} from "../../../../services/modals.service";
import {BaseModalService} from "../../services/base-modal.service";
import {ErrorService} from "../../../../services/error.service";
import {OpenDocumentModalParams, SetOpenMultiTypeFilesViewerModalParams} from "../types/document-files.types";
import {documentsGenerateButtons, generateFileIdKeys} from "../configs/documents-generate-modal-config";
import {documentsSignedButtons, signedFileIdKeys} from "../configs/documents-signed-modal-config";
import {bankDetailsFieldName} from "../../bank-details-modal/configs/bank-details-modal-config";
import {OpenFilesViewerModalParams} from "../../../../types/file.types";
import {defaultRecordData} from "../../../../models/default-record-data";
import {documentResourceType} from "../configs/documents-model-config";

@Injectable({
  providedIn: 'root'
})
export class DocumentOpenModalService {
  private filesParamsService: FilesParamsService = inject(FilesParamsService);
  private modalsService: ModalsService = inject(ModalsService);
  private baseModalService: BaseModalService = inject(BaseModalService);
  private errorService: ErrorService = inject(ErrorService);

  public async openFilesDocumentModal(openDocumentModalParams: OpenDocumentModalParams) {
    const { key } = openDocumentModalParams;
    switch (key) {
      case 'generate':
        await this.handleGenerateModal(openDocumentModalParams);
        break;
      case 'signed':
        await this.handleSignedModal(openDocumentModalParams);
        break;
      case 'bankDetails':
        await this.openBankDetailsModal(openDocumentModalParams);
        break;
    }
  }

  private async openBankDetailsModal({ documentsData, recordData }: OpenDocumentModalParams): Promise<void> {
    if (!documentsData?.bankDetails) {
      this.errorService.showErrorMessage('Нельзя добавить реквизиты: Сначала нужно добавить блогера.')
      return;
    }

    await this.modalsService.openBankDetails(bankDetailsFieldName, recordData);
  }

  private async handleGenerateModal({ recordData, isEditMode }: OpenDocumentModalParams): Promise<void> {
    const openModalParams = this.setOpenMultiTypeFilesViewerModalParams({
      filesData: documentsGenerateButtons,
      isGenerate: true,
      title: 'Сгенерировать докумены',
      recordData: recordData,
      isEditMode: isEditMode
    });

    await this.filesParamsService.getFilesParams(generateFileIdKeys, openModalParams.recordCalendarId);
    await this.modalsService.openMultiTypeFilesViewerModal(openModalParams);
  }

  private async handleSignedModal({ recordData, isEditMode }: OpenDocumentModalParams): Promise<void> {
    const openModalParams = this.setOpenMultiTypeFilesViewerModalParams({
      filesData: documentsSignedButtons,
      title: 'Подписанные докумены',
      recordData: recordData,
      isEditMode: isEditMode
    });

    await this.filesParamsService.getFilesParams(signedFileIdKeys, openModalParams.recordCalendarId);
    await this.modalsService.openMultiTypeFilesViewerModal(openModalParams);
  }


  private setOpenMultiTypeFilesViewerModalParams({ filesData, isGenerate, title, recordData, isEditMode }: SetOpenMultiTypeFilesViewerModalParams): OpenFilesViewerModalParams {
    const recordCalendarId = this.baseModalService.getRecordCalendarId(recordData || defaultRecordData);
    return {
      title: title,
      recordCalendarId: recordCalendarId,
      parentPath: documentResourceType.path,
      isGenerate: isGenerate,
      isAllFiles: true,
      recordId: Number(recordData?.id),
      filesData: filesData,
      keysType: isGenerate ? generateFileIdKeys : signedFileIdKeys,
      isEditMode: isEditMode
    };
  }
}
